import React from "react";

const TitlePage = (props) => {
  const {
    title,
    icon,
    size = "text-[18px]",
    buttonText,
    customElements,
    marginBottom = "mb-4",
    ...restButtonProps
  } = props;

  return (
    <div className="flex justify-between items-center">
      <h1 className={`text-title-black ${marginBottom} ${size} font-extrabold`}>
        {title}
      </h1>
      {icon ? (
        <button
          className="justify-center text-center mr-2 p-[5px] w-[6rem] rounded-[4px] bg-primary-blue border border-primary-blue text-white flex gap-3 items-center"
          {...restButtonProps}
        >
          {icon ? icon : null}
          {buttonText}
        </button>
      ) : null}
      {customElements}
    </div>
  );
};

export default TitlePage;
